export function unPadLeft(str: string): string {
  let ret = str.toString();

  while (ret.startsWith('0')) {
    ret = ret.substring(1);
  }

  return ret;
}
